'use client'

import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import { HELP_URLS } from 'help/constants/URLs'
import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { ContentContainer } from 'shipping-and-returns/containers/ReturnMethodsInfoContainer/components/ContentContainer/ContentContainer'

import text from 'fukku/styles/texts.module.scss'

interface ByPostContentProps {
	readonly isOutlet: boolean
}
export function ByPostContent({ isOutlet }: ByPostContentProps) {
	const { t } = useLabels()
	const { enabled: isNewHelpEnabled } = useFeatureFlag(featureFlagKeys.HelpPage)

	const placeholderHelpValues = {
		exchangesAndReturns: HELP_URLS.BY_POST_RETURN,
	}

	return (
		<ContentContainer
			description={
				<ClientLabel
					placeholderValues={placeholderHelpValues}
					linkProps={{
						className: text.bodyMRegularUnderline,
						target: '_blank',
						withLegacyLocale: !isNewHelpEnabled,
					}}
				>
					{isOutlet
						? t('myPurchases.online.details.returns.byPost.noLabel.bodycopy')
						: t('myPurchases.online.details.returns.byPost.bodycopy')}
				</ClientLabel>
			}
		/>
	)
}
